import { ToastContainer } from "react-toastify";
import { FaCheck } from 'react-icons/fa';
import Guide from "./Guide";

const CustomSize = (props) => {
    const {
        isOpen,
        togglePopup,
        customSizeForm,
        onSaveCustomSize,
        customSizeHeight,
        handleChange,
        handleHeightSelect,
        selectedHeight,
        customBodyType,
        selectedBodyType,
        handleBodyTypeSelect
    } = props;

    return (
        <div className="custom_size_wrapper">
            <ToastContainer
                position="top-right"
                className="toaster"
                autoClose={1500}
                hideProgressBar={true}
                pauseOnHover={false}
                draggable={false}
            />
            <span className="custom_size_head">Prefer a Custom Size?</span>
            <span className="custom_size" onClick={togglePopup}>
                Add Custom Size
            </span>

            {/* Popup Drawer - it slides in when isOpen is true */}
            <div className={`custom_size_popup ${isOpen ? 'open' : ''}`}>
                <div className="custom_size_popup_inner">
                    <div className="custom_size_popup_header">
                        <h4>Custom Size</h4>
                        <span className="close curser-pointer" onClick={togglePopup}>
                            <img src="../../../images/cancel.png" alt="cancel" />
                        </span>
                    </div>
                    <form onSubmit={onSaveCustomSize}>
                        <div className="custom_size_popup_content">
                            <div className="custom_size_popup_content_inner">
                                <div>
                                    <div className="custom_size_popup_header_guide d-flex justify-content-between align-items-center">
                                        <h4>Select your body type: </h4>
                                        <sapn type="button" className="guide_link curser-pointer" data-bs-toggle="modal" data-bs-target="#staticBackdrop">
                                            Guide
                                        </sapn>
                                    </div>
                                    <div className="custom_size_popup_content_type">
                                        <div className="custom_size_popup_content_type_inner row">
                                            {customBodyType?.map((item, index) => {
                                                return (
                                                    <div
                                                        key={index}
                                                        className={`custom_size_popup_content_type_inner_flex col-sm-3 col-4 d-flex justify-content-center`}
                                                        onClick={() => handleBodyTypeSelect(item.type)}
                                                    >
                                                        <div className={`${selectedBodyType === item.type ? 'selected' : ''}`}>
                                                            <img src={item?.image} alt=""/>
                                                            <p className="body_type_name">{item?.type}</p>
                                                        </div>
                                                        {selectedBodyType === item.type &&
                                                            <span className="check_mark_icon">
                                                                <FaCheck />
                                                            </span>
                                                        }
                                                    </div>
                                                )
                                            })}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="custom_size_popup_content_inner custom_size_popup_content_inner_img">
                                <img src="../../../images/breast.png" alt="breast" />
                                <input type="text" id="breastSize" name="breastSize" value={customSizeForm?.breastSize} placeholder="Bust (inches)" onChange={handleChange} required />
                            </div>
                            <div className="custom_size_popup_content_inner custom_size_popup_content_inner_img">
                                <img src="../../../images/weist.png" alt="weist" />
                                <input type="text" id="weistSize" name="weistSize" value={customSizeForm?.weistSize} placeholder="Weist (inches)" onChange={handleChange} required />
                            </div>
                            <div className="custom_size_popup_content_inner custom_size_popup_content_inner_img">
                                <img src="../../../images/hips.png" alt="hips" />
                                <input type="text" id="hipSize" name="hipSize" value={customSizeForm?.hipSize} placeholder="Hips (inches)" onChange={handleChange} required />
                            </div>
                            <div className="custom_size_popup_content_inner custom_size_popup_content_inner_img">
                                <img src="../../../images/shoulder.png" alt="shoulder" />
                                <input type="text" id="shoulder" name="shoulder" value={customSizeForm?.shoulder} placeholder="Shoulder (inches)" onChange={handleChange} required />
                            </div>
                            <div className="custom_size_popup_content_inner custom_size_popup_content_inner_img">
                                <img src="../../../images/armhole.png" alt="armhole" />
                                <input type="text" id="armhole" name="armhole" value={customSizeForm?.armhole} placeholder="Sleeve length" onChange={handleChange} required />
                            </div>
                            <div className="custom_size_popup_content_inner">
                                <div>
                                    <h4>Select or Enter Height</h4>
                                    <div className="custom_size_popup_content_height">
                                        <div className="custom_size_popup_content_height_inner row">
                                            {customSizeHeight?.map((item, index) => (
                                                <div
                                                    key={index}
                                                    className={`custom_size_popup_content_height_inner_flex col-2`} // Apply 'selected' class to the selected item
                                                    onClick={() => handleHeightSelect(item.height)}
                                                >
                                                    <div className={`${selectedHeight === item.height ? 'selected' : ''}`}>{item?.height}</div>
                                                </div>
                                            ))}
                                        </div>
                                        <input
                                            type="text"
                                            id="height"
                                            name="height"
                                            value={customSizeForm?.height}
                                            placeholder="Height (in inches/ feet)"
                                            onChange={handleChange}
                                            required
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="custom_file_input mb-2">
                                <input type="file" id="file" name="file" placeholder="Message" onChange={handleChange} />
                            </div>

                            <h5>Choose Photo : </h5>
                            <div className="custom_file_input mb-2">
                                <label htmlFor="file" className="custom_upload_btn d-flex">
                                    <p className="select_file mb-0">Choose File</p>
                                    {customSizeForm?.file && typeof customSizeForm.file === 'object' && (
                                        <>
                                            <p className="mb-0 select_file_name" >customSizeForm.file.name</p >
                                        </>
                                    )}
                                </label>

                                <input
                                    type="file"
                                    id="file"
                                    name="file"
                                    onChange={handleChange}
                                />
                            </div>
                            <div className="custom_size_popup_content_inner message_input">
                                <input type="text" id="remark" name="remark" value={customSizeForm?.remark} placeholder="Message" onChange={handleChange} />
                            </div>
                            <div className="custom_note my-3">
                                <p><b>Note :-</b> Extra ₹200 for customization.</p>
                                <p><b>Note :-</b> customized orders must be prepaid and will be shipped within 7-14 days. </p>
                            </div>
                            <div className="custom_size_popup_content_inner">
                                <button type="submit">Submit</button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>

            <div className="modal fade guide_popup_main" id="staticBackdrop" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
                <div className="modal-dialog modal-dialog-centered guide_popup_inner">
                    <div className="modal-content">
                        <div className="modal-header">
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <div className="modal-body">
                            <div>
                                <Guide customBodyType={customBodyType} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default CustomSize;